export default (params) => ({
  trigger: {
    name: 'login.click_login_intention_button',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'business_journey',
          'business_journey_header',
          'empty_shopping_cart',
          'empty_wishlist',
          'energy',
          'footer',
          'header',
          'header_account_creation',
          'home',
          'nudge_customer_service_homepage',
          'onboarding',
          'previously_viewed',
          'profile',
          'shopping_cart',
          'wishlist',
        ],
      },
    },
    event: {
      name: 'login',
    },
  },
});
